// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3NP0e","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__QDReD"};